import { EFilterEntity, IFilterSchemeExtended } from '../common';

export const arbitrageArbitragesHistoryFiltersScheme = (): Record<
  string,
  IFilterSchemeExtended
> => {
  return {
    range: {
      type: EFilterEntity.date_range,
      label: 'Time range',
      name: 'range',
      field: 'range',
      single: true,
    },
  };
};
